export const getNoticeStyles = ({ isError }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  padding: '12px 16px',
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.background.secondary,
  border: ({ palette }) => (isError ? `1px solid ${palette.error.main}` : 'none'),
});

export const noticeIconStyles = {
  flexShrink: 0,
  marginTop: '2px',
};
